// extracted by mini-css-extract-plugin
var _1 = "PostSearchItem-modulePostSearchItem__hMkui SearchItem-moduleSearchItem__qpbuZ";
export { _1 as "PostSearchItem" }
